/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Patch a task: workflow state, and (custom tasks only) title/description
 */
export type TaskPatchRequest = {
    /**
     * open | in_progress | done | dismissed
     */
    status?: TaskPatchRequest.status | null;
    /**
     * Custom tasks only — 400 if sent for a listing-inspector task
     */
    title?: string | null;
    /**
     * Custom tasks only — 400 if sent for a listing-inspector task
     */
    description?: string | null;
    /**
     * User UUIDs of assignees. Omitted = unchanged; [] = unassign everyone. Max 50.
     */
    assigneeIds?: Array<string> | null;
};
export namespace TaskPatchRequest {
    /**
     * open | in_progress | done | dismissed
     */
    export enum status {
        OPEN = 'open',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        DISMISSED = 'dismissed',
    }
}

